var render, staticRenderFns
import script from "./ClTabs.tsx?vue&type=script&lang=tsx&"
export * from "./ClTabs.tsx?vue&type=script&lang=tsx&"
import style0 from "./ClTabs.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports